import script from "./AdvConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./AdvConfirmation.vue?vue&type=style&index=0&id=6f0391f6&scoped=true&lang=sass"

import exportComponent from "/Users/nika/Documents/Projects/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0391f6"]])

export default __exports__